import { apolloProvider } from '@/modules/myStageGraphQL';
import { GET_TRAINER_HTML_MSB, GET_USER_TYPE_HTML_MSB } from '@/graphql/Mystage/material';
import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';

export const GetUserTypeHtmlService = {
  // Fetch HTML material from new MSB endpoint
  msb: async (isTrainerHtml, params, callback) => {
    logger.debug(`[Materials][Trainer HTML] Fetching HTML from new GraphQL endpoint`, {
      operation: 'materials:get_trainer_html'
    });

    const query = isTrainerHtml ? GET_TRAINER_HTML_MSB : GET_USER_TYPE_HTML_MSB;
    const payload = isTrainerHtml ? {
      p: parseInt(params.p),
      r: parseInt(params.r),
    } : {
      r: parseInt(params.r),
      l: parseInt(params.l),
      rv: parseInt(params.rv),
    };
    const client = apolloProvider.defaultClient;

    try {
      const { data } = await client.query({
        query: query,
        fetchPolicy: 'no-cache',
        variables: payload
      });

      const dataReturn = isTrainerHtml ? data?.trainerHtmlMaterial : data.userHtmlMaterial;
      if (dataReturn) {
        callback(dataReturn);
      } else {
        logger.error(`[Materials][Trainer HTML] Empty result from HTML GraphQL API`, {
          operation: 'materials:get_trainer_html',
          event_type: 4,
          payload: payload
        });
      }
    } catch (error) {
      logger.error(`[Materials][Trainer HTML] Error fetching HTML material`, {
        error: error.message,
        operation: 'materials:get_trainer_html'
      });
      callback(false);
    }
  },

  // Fetch HTML material from legacy REST API
  legacy: async (isTrainerHtml, params, callback) => {
    logger.debug(`[Materials][Trainer HTML] Fetching HTML from legacy endpoint`, {
      operation: 'materials:get_trainer_html'
    });
    
    await bizmatesApi.get('lessonmaterials/trainer_html.json',  { params: params } , (response) => {
      if (response.data) {
        callback(response.data);
      } else {
        logger.error(`[Materials][Trainer HTML] Empty result from legacy HTML API`, {
          operation: 'materials:get_trainer_html',
          event_type: 4
        });
      }
    });
  }
};
